import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          热度榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          实时更新，当前最受关注的话题排行
        </p>

        <div className="max-w-3xl mx-auto">
          {rankingData.map((item) => (
            <a
              key={item.rank}
              href="#carousel"
              className="group flex items-center gap-4 p-4 hover:bg-background-100 border-b border-background-200/40 last:border-b-0 transition-colors duration-200 cursor-pointer"
            >
              <div className="w-8 h-8 flex items-center justify-center shrink-0">
                {item.rank <= 3 ? (
                  <span className={`text-lg font-bold ${
                    item.rank === 1 ? 'text-accent-500' :
                    item.rank === 2 ? 'text-secondary-300' :
                    'text-primary-400'
                  }`}>
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-sm font-medium text-foreground-500">{item.rank}</span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-800 group-hover:text-primary-400 transition-colors truncate">
                  {item.title}
                </p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className="text-xs text-foreground-500">{item.heat}</span>
                <span className={`text-xs px-1.5 py-0.5 rounded ${
                  item.tag === '爆' ? 'bg-primary-500/15 text-primary-400' :
                  item.tag === '热' ? 'bg-accent-100 text-accent-700' :
                  'bg-secondary-100 text-secondary-600'
                }`}>
                  {item.tag}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}